module.exports = __webpack_public_path__ + "static/media/flag-nso.780e5e0c.webp";